angular.module('galilai.creator').factory('generator', function ($timeout, $rootScope, api, parserService, layoutService) {

    const JOB_INTERVAL_CHECK = 800
    const MOCK_GENERATION = false
    const DYNAMIC_MAX_WAIT = 15000
    const MAX_HASHTAGS = 25
    const MAX_CAPTION_LENGTH = 2000

    const SMART_LAYOUTS_STARTER = 's-'

    function PostsManager() {
        let self = this
        self.state = {
            parsed: [],
            posts: [],
            items: [],
            favorites: [],
        }

        self.createExistingPost = function(rows, params) {
            let format = params?.calendar?.what || 'post'

            function convertToItem(row, index) {
                let item = {
                    id: index,
                    handle: self.config.handle,
                }
                if (params?.author) {
                    item.author = params.author
                }
                item = Object.assign(item, row)
                return item
            }

            // Remove settings
            let themeToSave = JSON.parse(JSON.stringify(self.getTheme()))
            if (themeToSave.settings) {
                delete themeToSave.settings
            }

            if (format && MAP_POST_SIZES[format]) {
                themeToSave.size = MAP_POST_SIZES[format]
            }

            let mode = params?.mode || 'scratch'
            let newPost = {
                item: rows.map(convertToItem),
                theme: themeToSave,
                meta: {
                    edited: true,
                    project: self.config.project,
                    instagram: self.config.handle,
                    uuid: safeGetStorage('galilai.uuid'),
                }
            }
            if (mode == 'write') {
                delete newPost.meta.edited
            }
            if (params?.caption) {
                newPost.caption = params.caption
            }
            if (params?.calendar) {
                newPost.meta.calendar = params.calendar
            }

            let extraParamsURL = ''
            try {
                if (params?.calendar?.date) {
                    extraParamsURL += '&pdate=' + params.calendar.date.toISOString()
                    extraParamsURL += '&ptime=' + '09:00'
                }
            } catch (e) {
                console.log('Error on date', e)
            }
            newPost.meta[mode] = true

            return api.getOrCreatePost(newPost, mode).then(function(res) {
                if (params?.onCreate) {
                    params.onCreate(res.data)
                    return
                }
                let postUrl = '?id=' + res.data._id
                if (extraParamsURL) {
                    postUrl += extraParamsURL
                }
                postUrl += '&embed=true'
                if (IS_APP) {
                    $rootScope.$emit('openEditModal', {url: postUrl})
                } else {
                    window.open(location.pathname + postUrl, '_blank')
                }
            })
            .catch(function(err) {
                if (params?.onError) {
                    params.onError(err)
                    return
                }
                showError(gettext('error.creating_scratch'))
            })
        }

        self.hasSelectedItems = function() {
            return self.state.items && self.state.items.some(function(item) {
                return item.selected
            })
        }

        self.saveItems = function(params) {
            self.loading = true
            let totalSelected = self.state.items.filter(function(item) {
                return item.selected
            }).length

            let totalToSave = self.state.items.filter(function(item) {
                return item.selected || item.favorite
            }).length

            if (totalSelected == 0) {
                self.loading = false
                return Promise.reject('no_selection')
            }
            // Remove settings ? WHY?
            let themeToSave = JSON.parse(JSON.stringify(self.getTheme()))
            if (themeToSave.settings) {
                delete themeToSave.settings
            }

            let meta = {
                project: self.config.project,
                instagram: self.config.handle,
                uuid: safeGetStorage('galilai.uuid'),
            }

            if (params.generateFull) {
                meta.generateFull = true
            }

            if (params && params.link) {
                meta.link = params.link
            }

            // Prepare for saving
            let itemsToSave = self.state.items.filter(function(item) {
                return item.selected || item.favorite
            }).map(function(item) {
                let postToCreate = {
                    item: item,
                }
                // Add full layout
                if (postToCreate.item && postToCreate.item.fullLayout) {
                    postToCreate.layout = layoutService.getExpandedLayout(postToCreate.item.layout)
                    if (!postToCreate.layout) {
                        postToCreate.layout = postToCreate.item.fullLayout.data
                    }
                    delete postToCreate.item.fullLayout
                }
                return postToCreate
            })

            return api.createPostsFromItems({
                items: itemsToSave,
                theme: themeToSave,
                meta: meta,
            }).then(function(response) {
                let data = response.data

                // Check if data.ids length is the same as items length
                if (data.ids.length != totalToSave) {
                    throw new Error('save_error')
                }
                // Only add selected
                self.state.items.filter(function(item) {
                    return item.selected || item.favorite
                }).forEach(function(item, index) {
                    item.serverId = data.ids[index]
                })

                self.rebuildPosts()
                // Return only selected posts
                let selectedPosts = JSON.parse(JSON.stringify(self.state.posts.filter(post => post.data.items[0].selected)))
                // Remove to avoid duplicates
                self.removeSavedPosts()
                return selectedPosts
            })
            .finally(function() {
                self.loading = false
                $timeout(angular.noop)
            })
        }

        self.removeSavedPosts = function() {
            try {
                const indicesToRemove = [];
                self.state.posts.forEach((item, index) => {
                    if (item._id) {
                        indicesToRemove.push(index);
                    }
                });

                // Removed saved items
                for (let i = indicesToRemove.length - 1; i >= 0; i--) {
                    const idx = indicesToRemove[i];
                    self.state.items.splice(idx, 1);
                    self.state.parsed.splice(idx, 1);
                    self.state.posts.splice(idx, 1);
                }
                self.rebuildPosts()
                $timeout(angular.noop);
            } catch (e) {
                console.log('Error removing saved posts', e)
            }
        }

        self.onUpdatePost = function(data) {
            let fullLayout = null
            try {
                if (data.changes && data.changes.fullLayout) {
                    fullLayout = data.changes.fullLayout
                    let fullLayoutId = fullLayout.id || fullLayout?.data?.label
                    data.changes.layout = fullLayoutId
                    layout = fullLayout.data
                    if (!self.state.items[data.id].meta) {
                        self.state.items[data.id].meta = {}
                    }
                    self.state.items[data.id].meta.layout = fullLayoutId
                }
            } catch (e) {
                console.log(e)
            }
            self.state.items[data.id] = Object.assign(self.state.items[data.id] || {}, data.changes)
            self.renderItem(data.id)
        }

        self.getTheme = function() {
            let theme = JSON.parse(JSON.stringify(self.config.theme || BASE_THEME))
            try {
                if (theme?.settings) {
                    for (key in theme?.settings) {
                        if (theme?.settings[key] && typeof theme.settings[key].visual) {
                            delete theme.settings[key].visual
                        }
                    }
                }
            } catch (e) {
                console.log('Error on getTheme', e)
            }
            return theme
        }

        self.renderItem = function(index) {
            let item = self.state.items[index]
            let layout = layoutService.getExpandedLayout(item.layout)
            if (!layout) {
                console.error('Layout not found for item', index, item, item.layout)
                logError({
                    message: 'Layout not found for item',
                }, {
                    item: item,
                    index: index,
                    layout: item.layout
                })
            }
            // TODO - if this returns null, we should use the default layout
            let post = {
                data: {
                    items: [
                        item,
                    ],
                    layouts: [ layout ],
                    theme: self.getTheme()
                }
            }
            if (item.serverId) {
                post._id = item.serverId
                delete item.serverId
            }
            // TODO - Should it be here?
            self.state.posts[index] = post
            self.state.parsed[index] = parserService.getFullParsed(post, 0)
        }

        self.rebuildPosts = function() {
            self.state.items.map((item, index) => {
                self.renderItem(index)
            })
        }

        self.onNewPost = function(item) {
            let currentIndex = self.state.items.length
            try {
                // Add dynamic layout
                if (getLayoutParentId({ label: item.content.layout }) && !layoutService.getExpandedLayout(item.content.layout)) {
                    item.content.originalLayout = item.content.layout
                    item.content.layout = 'empty.loading'
                    item.content.meta.layout = item.content.layout
                } else if (item.content.layout.startsWith(SMART_LAYOUTS_STARTER) && !layoutService.getExpandedLayout(item.content.layout)) {
                    item.content.originalLayout = item.content.layout
                    item.content.layout = 'empty.loading'
                    item.content.meta.layout = item.content.layout
                }

                self.state.items[currentIndex] = item.content
                self.renderItem(currentIndex)
            } catch (err) {
                console.log('Error on new post', err)
            }
            return currentIndex
        }

        self.update = function(params) {
            self.config = Object.assign({}, self.config, params)
        }

        self.removePost = function(index, parsedPost) {
            self.state.items.splice(index, 1)
            self.state.parsed.splice(index, 1)
            self.state.posts.splice(index, 1)

            $timeout(angular.noop)
        }

        self.removePosts = function(kind) {
            showConfirm(gettext('label.are_you_sure'), null, function(status) {
                if (status) {
                    if (kind == 'all') {
                        self.state.items = []
                        self.state.parsed = []
                        self.state.posts = []
                    } else if (kind == 'non-relevant') {
                        let indexesToRemove = []
                        self.state.items.map(function(item, index) {
                            if (!item.favorite && !item.selected) {
                                indexesToRemove.push(index)
                            }
                        })
                        for (let i = indexesToRemove.length - 1; i >= 0; i--) {
                            self.state.items.splice(indexesToRemove[i], 1)
                            self.state.parsed.splice(indexesToRemove[i], 1)
                            self.state.posts.splice(indexesToRemove[i], 1)
                        }
                    }
                    $timeout(angular.noop)
                }
            })
        }

        self.favoritePost = function(index, parsedPost) {
            let item = self.state.items[index]
            self.state.items[index].favorite = !item.favorite
            self.state.parsed[index].extra = {
                favorite: item.favorite,
                selected: item.selected,
            }
            $timeout(angular.noop)
        }

        self.selectPost = function(index, parsedPost) {
            let item = self.state.items[index]
            self.state.items[index].selected = !item.selected
            self.state.parsed[index].extra = {
                favorite: item.favorite,
                selected: item.selected,
            }

            if (!self.config.multiple) {
                self.state.items.map(function(row, itemIndex) {
                    if (itemIndex == index) {
                        return
                    }
                    self.state.items[itemIndex].selected = false
                    if (self.state.parsed[itemIndex].extra) {
                        self.state.parsed[itemIndex].extra.selected = false
                    }
                })
            }
        }

        self.toggleSelectAll = function(state) {
            for (let index in self.state.items) {
                let item = self.state.items[index]
                item.selected = state
                self.state.parsed[index].extra = {
                    favorite: item.favorite,
                    selected: item.selected,
                }
            }
        }
    }

    function CaptionGenerator() {
        self = this

        self.cleanHashTags = function(originalCaption) {
            let resultCaption = ''

            try {
                function getHashtagsFromText(text) {
                    if (!text) {
                        return []
                    }
                    let hashtags = text.match(/#[a-zA-Z0-9\u00C0-\u00FF]+/g)
                    if (!hashtags) {
                        hashtags = []
                    }
                    return hashtags
                }
                let caption = originalCaption
                if (!caption || typeof caption !== 'string') {
                    return
                }
                // TODO - Need to pass fixed hashtags
                let fixedHashtags = ''

                // hashtags can also have accents á etc
                let hashtags = getHashtagsFromText(caption)
                let fixed = getHashtagsFromText(fixedHashtags)
                let newHashtags = hashtags.map(function(hashtag) {
                    return hashtag.toLowerCase()
                })
                let newCaption = caption

                fixed.forEach(function(fixedHashtag) {
                    if (newHashtags.indexOf(fixedHashtag) == -1) {
                        newHashtags.push(fixedHashtag)
                    }
                })

                hashtags.forEach(function(hashtag) {
                    newCaption = newCaption.replace(hashtag, '')
                })

                newHashtags = newHashtags.filter(function(hashtag) {
                    return hashtag.trim().length > 0
                })

                newCaption = newCaption.trim()

                if (newHashtags.length > 0) {
                    newHashtags = newHashtags.slice(0, MAX_HASHTAGS)
                    let newCaptionTemp = newCaption + '\n\n'
                    newHashtags.forEach(function(hashtag) {
                        if (newCaptionTemp.length + hashtag.length + 1 < MAX_CAPTION_LENGTH) {
                            newCaptionTemp += hashtag + ' '
                        }
                    })
                    resultCaption = newCaptionTemp.trim()
                } else {
                    resultCaption = newCaption.trim()
                }
            } catch (e) {
                logError({
                    message: 'Error cleaning hashtags',
                    error: e
                })
                resultCaption = originalCaption
            }
            return resultCaption
        }

        self.generate = function(data, cb) {
            let formName = 'creator/caption'
            let baseText = data.text

            // Modify
            if (data.instructions && data.instructions.trim().length > 0) {
                if (data.caption && data.caption.trim().length > 0 && data.kind == 'modify') {
                    baseText = data.caption
                }
                baseText += '\n---\n' + $scope.instructions + '\n'
                if (data.kind == 'modify') {
                    formName = 'creator/chat'
                }
            }

            let input = {
                form: formName,
                inputs: {
                    context: baseText,
                    language: data.language,
                }
            }

            let text = ''

            function improveResult(text) {
                text = text.replace(/^"/, '')
                text = text.replace(/^'/, '')
                text = text.replace(/^“/, '')
                text = text.replace(/^‘/, '')
                text = text.replace(/"$/, '')
                text = text.replace(/'$/, '')
                text = text.replace(/”$/, '')
                text = text.replace(/’$/, '')
                text = text.replace(/\*\*/g, '')
                return text
            }
            api.generateStream(input, function(err, response, done, reader) {

                if (err) {
                    showError(gettext('error.generating.content'))
                    cb(err)
                    return
                }
                response = improveResult(response)
                text += response;
                $timeout(() => {
                    if (done) {
                        if (reader) {
                            reader.cancel()
                        }
                        text = self.cleanHashTags(text)
                    }
                    cb(null, text, done, reader)
                })
            })
        }
    }

    function Generator() {
        let self = this

        let manager = new PostsManager()
        self.captionGenerator = new CaptionGenerator()
        self.manager = manager
        self.dynamicLoading = {}

        function init(params) {
            if (params.cbs) {
                self.cbs = params.cbs
            }
        }

        self.getReversedIndex = function($index) {
            return manager.state.parsed.length - $index - 1
        }

        self.getParsedPosts = function() {
            return manager.state.parsed
        }

        self.hasPosts = function() {
            return manager.state.parsed.length > 0
        }

        self.getParsedPostsReversed = function() {
            return manager.state.parsed.slice().reverse()
        }

        self.getPostReversedAtIndex = function($index) {
            return manager.state.posts[manager.state.parsed.length - $index - 1]
        }

        self.getPosts = function() {
            return manager.state.posts
        }

        self.getSelectedPosts = function() {
            return JSON.parse(JSON.stringify(manager.state.posts.filter(post => post.data.items[0].selected)))
        }

        self.onGenerateError = function(err) {
            if (self.loading) {
                if (gettext('error.generator_' + err.message)) {
                    showError(gettext('error.generator_' + err.message))
                } else {
                    showError(gettext('error.generic'))
                }
            }
            self.loading = false
            $timeout(angular.noop)

        }

        self.onGenerateFinished = function() {
            self.loading = false
            $timeout(angular.noop)
        }

        self.onUpdateItem = function(item) {
            manager.onUpdatePost(item)
            $timeout(angular.noop, 100)
        }

        self.onNewItem = function(item) {
            let id = manager.onNewPost(item)
            self.generateDynamicContent(item.content, id)
        }

        self.generateDynamicContent = function(item, itemId) {
            item = JSON.parse(JSON.stringify(item))

            // Smart layouts
            let isExpanded = layoutService.getExpandedLayout(item.fullLayout?.label || item.fullLayout?.data?.label)
            if (item.fullLayout && !isExpanded) {
                layoutService.addDynamicLayout({
                    data: item.fullLayout,
                    id: item.originalLayout || item.fullLayout?.label || item.fullLayout?.data?.label,
                })
                .finally(function() {
                    self.onUpdateItem({
                        id: itemId,
                        changes: {
                            fullLayout: {
                                data: item.fullLayout,
                                id: item.originalLayout || item.fullLayout?.label || item.fullLayout?.data?.label,
                            }
                        }
                    })
                })
                .catch(err => console.log('Error adding dynamic layout', err));
            }

            if (item.settings.dynamic || item.originalLayout) {
                let paramsDynamic = JSON.parse(JSON.stringify(item))
                if (item.originalLayout && !item.fullLayout) {
                    paramsDynamic.layout = item.originalLayout
                }
                paramsDynamic.project = self.config.project

                self.dynamicLoading[itemId] = true
                let timerCancel = setTimeout(() => {
                    if (self.dynamicLoading[itemId]) {
                        delete self.dynamicLoading[itemId]
                        self.onUpdateItem({
                            id: itemId,
                            changes: {
                                image: null
                            }
                        })
                    }
                }, DYNAMIC_MAX_WAIT)

                api.generateDynamic(paramsDynamic).then(function (response) {
                    let data = response.data
                    let changes = {}
                    if (data.image && data.image.url) {
                        changes.image = data.image.url
                    } else if (item.settings.dynamic && item.settings.dynamic.image) {
                        changes.image = null
                    }
                    if (data.title) {
                        changes.title = data.title
                    }
                    if (typeof data.description != 'undefined') {
                        changes.description = data.description
                    }
                    function sendUpdate() {
                        self.onUpdateItem({
                            id: itemId,
                            changes: changes
                        });
                    }

                    if (data.layout) {
                        changes.fullLayout = data.layout;
                        layoutService.addDynamicLayout(data.layout)
                            .finally(() => sendUpdate())
                            .catch(err => console.log('Error adding dynamic layout', err));
                    } else {
                        sendUpdate();
                    }
                }).catch(function (err) {
                    console.log('Error generating dynamic content', err)
                    if (item.settings.dynamic && item.settings.dynamic.image) {
                        self.onUpdateItem({
                            id: itemId,
                            changes: {
                                image: null
                            }
                        })
                    }
                })
                .finally(() => {
                    delete self.dynamicLoading[itemId]
                    clearTimeout(timerCancel)
                })
            }
        }

        function mockGeneration() {
            let layout = "questions.badge.no-box"

            let job = {
                "status": "success",
                "data": {
                    "inputs": {
                        "context": "Futuro do trabalho e RH",
                        "single": true,
                        "language": "pt"
                    },
                    "results": [
                        {
                            "type": "item",
                            "content": {
                                "title": "Meu time apresenta preconceitos inconscientes. Como abordar isso sem gerar desconforto?",
                                "badge": "Diversidade Inclusiva",
                                "layout": layout,
                                "settings": {
                                    "dynamic": {
                                        "image": true,
                                        "content": true
                                    }
                                },
                                "meta": {
                                    "type": "question",
                                    "layout": layout,
                                    "language": "pt"
                                },
                                "image": "https://upload.wikimedia.org/wikipedia/commons/b/b1/Loading_icon.gif?20151024034921"
                            }
                        }
                    ],
                    "user": "6305e0e567c5595e5d6b011d"
                }
            }
            let items = []
            for (let parseItem of job.data.results) {
                items.push(parseItem)
                self.onNewItem(parseItem)
            }
        }

        self._generate = function(input) {
            self.loading = true
            const currentSeed = Math.floor(Math.random() * 100000)
            input.inputs.seed = currentSeed
            input.inputs.uuid = safeGetStorage('galilai.uuid')
            if (self.generateInterval) {
                clearInterval(self.generateInterval)
            }
            api.generatePosts(input)
                .then((response) => {
                    let jobId = response.data.job

                    if (response.data.message && response.data.error) {
                        self.onGenerateError({ message: response.data.message })
                        return
                    }
                    if (!jobId) {
                        self.onGenerateError({ message: 'errors.job' })
                        return
                    }

                    let items = []
                    self.generateInterval = setInterval(() => {
                        api.getJob(jobId, 'post')
                        .then(res => {
                            let job = res.data
                            if (!job || !job.data || !job.data.results || !job.data.results.length) {
                                // If job is not pending and there are no results
                                if (job.status != 'pending') {
                                    clearInterval(self.generateInterval)
                                    self.onGenerateFinished()
                                }
                                return
                            }
                            // On new items
                            let filteredItems = job.data.results.filter(item => items.indexOf(item) == -1)
                            for (let parseItem of filteredItems) {
                                items.push(parseItem)
                                self.onNewItem(parseItem)
                            }

                            // On finish
                            if (job.status == 'success') {
                                clearInterval(self.generateInterval)
                                self.onGenerateFinished()
                            }
                        })
                        .catch((err) => {
                            clearInterval(self.generateInterval)
                            self.onGenerateError(err)
                        })
                    }, JOB_INTERVAL_CHECK)
                })
                .catch((err) => {
                    self.onGenerateError(err)
                })
        }

        self.generate = function(input) {
            layoutService.waitForLayouts().then(() => {
                if (MOCK_GENERATION) {
                    return mockGeneration()
                } else {
                    return self._generate(input)
                }
            })
        }

        self.save = function(params) {
            if (Object.keys(self.dynamicLoading).length > 0) {
                return Promise.reject('dynamic_loading')
            }
            return manager.saveItems(params)
        }

        self.update = function(params) {
            self.config = Object.assign({}, self.config, params)
            self.manager.update(self.config)
        }

        self.isLoading = function() {
            return self.loading || self.manager.loading || (self.dynamicLoading && Object.keys(self.dynamicLoading).length > 0)
        }

        self.startLoading = function() {
            self.loading = true
        }

        self.stopLoading = function() {
            self.loading = false
        }

        self.reset = function() {
            self.loading = false
            self.dynamicLoading = {}
            self.manager.state = {
                parsed: [],
                posts: [],
                items: [],
                favorites: [],
            }
            self.manager.config = {}
            self.manager.update(self.manager.config)
        }

        return {
            startLoading: self.startLoading,
            stopLoading: self.stopLoading,
            reset: reset,
            isLoading: isLoading,
            update: update,
            save: save,
            generate: generate,
            getPosts: getPosts,
            getSelectedPosts: getSelectedPosts,
            getParsedPosts: getParsedPosts,
            getParsedPostsReversed: self.getParsedPostsReversed,
            getPostReversedAtIndex: self.getPostReversedAtIndex,
            hasPosts: hasPosts,
            getReversedIndex: self.getReversedIndex,
            removeSavedPosts: self.manager.removeSavedPosts,
            removePosts: self.manager.removePosts,
            removePost: self.manager.removePost,
            favoritePost: self.manager.favoritePost,
            selectPost: self.manager.selectPost,
            toggleSelectAll: self.manager.toggleSelectAll,
            createExistingPost: self.manager.createExistingPost,
            generateCaptions: self.captionGenerator.generate,
            hasSelectedItems: self.manager.hasSelectedItems,
            getTheme: self.manager.getTheme,
        }
    }

    return Generator
})